import React from 'react'
import { Navigate } from 'react-router-dom'
import { useGlobalStore} from '@robing-org/common-lib'

// PrivateRoute 用于检查是否有 token 来决定是否可以访问
const PrivateRoute = ({ element }: { element: React.ReactElement }) => {
  // const token = getAuthCache<string>(TOKEN_KEY)
  const token=useGlobalStore.getState().token
  if (!token) {
    return <Navigate to="/login" />
  }
  return element
}

export default PrivateRoute
